import { ObjetKStatus, enumValue } from '@siclop/kstone-vue'
import { LeaveCategory } from '../enums/LeaveCategory'

/**
 * Solde d'un salarié pour un type de congé et une période (calculé par l'API).
 *
 * Congés payés : période d'acquisition du 1er juin `periodStartYear` au 31 mai suivant, à prendre jusqu'au
 * `takingDeadline`. RTT et autres types : année civile. Seuls `manualAdjustment`, `adjustmentReason` et
 * `extendedDeadline` sont saisis (correction RH, `POST /leave-balances/{id}/adjust`).
 */
export class LeaveBalance extends ObjetKStatus {
  employeeId: number = 0
  leaveTypeId: number = 0
  periodStartYear: number = 0
  periodStart: string = ''
  periodEnd: string = ''
  takingDeadline: string = ''
  acquired: number = 0
  taken: number = 0
  pending: number = 0
  expired: number = 0
  manualAdjustment: number = 0
  adjustmentReason: string | null = null
  extendedDeadline: string | null = null
  lastComputedAt: string | null = null
  leaveTypeName?: string
  leaveTypeCode?: string
  leaveTypeCategory?: LeaveCategory
  /** Disponible : acquis + correction − pris − en attente − expiré (renvoyé par l'API). */
  remaining: number = 0

  constructor(data?: Partial<LeaveBalance>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId ?? 0
      this.leaveTypeId = data.leaveTypeId ?? 0
      this.periodStartYear = data.periodStartYear ?? 0
      this.periodStart = data.periodStart ?? ''
      this.periodEnd = data.periodEnd ?? ''
      this.takingDeadline = data.takingDeadline ?? ''
      this.acquired = data.acquired ?? 0
      this.taken = data.taken ?? 0
      this.pending = data.pending ?? 0
      this.expired = data.expired ?? 0
      this.manualAdjustment = data.manualAdjustment ?? 0
      this.adjustmentReason = data.adjustmentReason ?? null
      this.extendedDeadline = data.extendedDeadline ?? null
      this.lastComputedAt = data.lastComputedAt ?? null
      this.leaveTypeName = data.leaveTypeName
      this.leaveTypeCode = data.leaveTypeCode
      this.leaveTypeCategory = data.leaveTypeCategory == null
        ? undefined
        : enumValue(LeaveCategory, data.leaveTypeCategory, LeaveCategory.Other)
      this.remaining = data.remaining
        ?? this.acquired + this.manualAdjustment - this.taken - this.pending - this.expired
    }
  }
}
